export default function (app) {
  app.controller('klNotificationCtrl', [
    'klNotificationService',
    function (NotificationService) {
      let ctrl = this;

      ctrl.service = NotificationService;
      ctrl.getError = NotificationService.getError;
      ctrl.getNotification = NotificationService.getNotification;
      ctrl.getNotificationStatus = NotificationService.getNotificationStatus;
    },
  ]);
}
